var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('van-notice-bar', {
    attrs: {
      "left-icon": "volume-o",
      "scrollable": false,
      "text": "温馨提示：每件邮件限一副车牌（含：一主一挂)"
    }
  }), _vm._m(0), _c('van-form', {
    on: {
      "submit": _vm.getCaptcha
    }
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('van-field', {
    attrs: {
      "readonly": "",
      "required": "",
      "name": "r_send",
      "label": "办理城市",
      "placeholder": "选择地市",
      "rules": [{
        required: true
      }],
      "disabled": _vm.companyDisabled
    },
    on: {
      "click": function click($event) {
        _vm.showSendCityPicker = true;
      }
    },
    model: {
      value: _vm.sendCity,
      callback: function callback($$v) {
        _vm.sendCity = $$v;
      },
      expression: "sendCity"
    }
  }), _c('div', {
    staticClass: "pop-content"
  }, [_c('van-popup', {
    attrs: {
      "round": "",
      "position": "bottom"
    },
    model: {
      value: _vm.showSendCityPicker,
      callback: function callback($$v) {
        _vm.showSendCityPicker = $$v;
      },
      expression: "showSendCityPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "title": "选择地市",
      "columns": _vm.cities
    },
    on: {
      "cancel": function cancel($event) {
        _vm.showSendCityPicker = false;
      },
      "confirm": _vm.onSendCityConfirm
    }
  })], 1)], 1), _c('van-field', {
    attrs: {
      "readonly": "",
      "required": "",
      "name": "p_company",
      "label": "办理站点",
      "placeholder": "选择站点",
      "rules": [{
        required: true
      }],
      "disabled": _vm.companyDisabled
    },
    on: {
      "click": function click($event) {
        _vm.showSendSitePicker = true;
      }
    },
    model: {
      value: _vm.p_company,
      callback: function callback($$v) {
        _vm.p_company = $$v;
      },
      expression: "p_company"
    }
  }), _c('div', {
    staticClass: "pop-content"
  }, [_c('van-popup', {
    attrs: {
      "round": "",
      "position": "bottom"
    },
    model: {
      value: _vm.showSendSitePicker,
      callback: function callback($$v) {
        _vm.showSendSitePicker = $$v;
      },
      expression: "showSendSitePicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "title": "选择站点",
      "value-key": "org_name",
      "columns": _vm.sendSiteList
    },
    on: {
      "cancel": function cancel($event) {
        _vm.showSendSitePicker = false;
      },
      "confirm": _vm.onSendSiteConfirm
    }
  })], 1)], 1), _c('van-field', {
    attrs: {
      "name": "r_name",
      "label": "收件人姓名",
      "required": "",
      "clickable": "",
      "placeholder": "请填写用户名",
      "rules": [{
        required: true
      }]
    },
    model: {
      value: _vm.username,
      callback: function callback($$v) {
        _vm.username = $$v;
      },
      expression: "username"
    }
  }), _c('van-field', {
    attrs: {
      "type": "tel",
      "name": "r_mobile",
      "label": "联系电话",
      "required": "",
      "clickable": "",
      "placeholder": "请填写联系电话",
      "errormessage": "",
      "rules": [{
        required: true,
        pattern: /^1[0-9]{10}$/,
        message: '请填写正确的联系电话'
      }]
    },
    model: {
      value: _vm.telephone,
      callback: function callback($$v) {
        _vm.telephone = $$v;
      },
      expression: "telephone"
    }
  }), _c('van-field', {
    attrs: {
      "readonly": "",
      "required": "",
      "name": "r_area",
      "label": "寄达省份",
      "placeholder": "选择地区",
      "rules": [{
        required: true
      }]
    },
    on: {
      "click": function click($event) {
        _vm.showAreaPicker = true;
      }
    },
    model: {
      value: _vm.address_p,
      callback: function callback($$v) {
        _vm.address_p = $$v;
      },
      expression: "address_p"
    }
  }), _c('div', {
    staticClass: "pop-content"
  }, [_c('van-popup', {
    attrs: {
      "round": "",
      "position": "bottom"
    },
    model: {
      value: _vm.showAreaPicker,
      callback: function callback($$v) {
        _vm.showAreaPicker = $$v;
      },
      expression: "showAreaPicker"
    }
  }, [_c('van-area', {
    attrs: {
      "show-toolbar": "",
      "title": "选择地区",
      "area-list": _vm.areaList,
      "value": ""
    },
    on: {
      "cancel": function cancel($event) {
        _vm.showAreaPicker = false;
      },
      "confirm": _vm.onAreaConfirm
    }
  })], 1)], 1), _c('van-field', {
    attrs: {
      "name": "r_addr",
      "label": "详细地址",
      "rows": "1",
      "autosize": "",
      "required": "",
      "clickable": "",
      "type": "textarea",
      "placeholder": "请填写邮寄详细地址",
      "rules": [{
        required: true
      }]
    },
    model: {
      value: _vm.address,
      callback: function callback($$v) {
        _vm.address = $$v;
      },
      expression: "address"
    }
  }), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "p_type",
      "label": "车辆类型",
      "value": _vm.vehicleType,
      "placeholder": "选择车辆类型",
      "show-error": "",
      "required": "",
      "validate-trigger": "onChange",
      "rules": [{
        validator: _vm.validator,
        required: true
      }]
    },
    on: {
      "click": function click($event) {
        _vm.showVehiclePicker = true;
      }
    }
  }), _c('div', {
    staticClass: "pop-content"
  }, [_c('van-popup', {
    attrs: {
      "round": "",
      "position": "bottom"
    },
    model: {
      value: _vm.showVehiclePicker,
      callback: function callback($$v) {
        _vm.showVehiclePicker = $$v;
      },
      expression: "showVehiclePicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "title": "选择车辆类型",
      "columns": _vm.vehicleColumns
    },
    on: {
      "cancel": function cancel($event) {
        _vm.showVehiclePicker = false;
      },
      "confirm": _vm.onVehicleConfirm
    }
  })], 1)], 1), _c('van-field', {
    attrs: {
      "readonly": "",
      "name": "p_code",
      "label": "车牌号码",
      "required": "",
      "value": _vm.vehicleCode,
      "placeholder": "请填写车牌号码",
      "rules": [{
        required: true
      }]
    },
    on: {
      "click": _vm.onShowInput
    }
  }), _c('van-field', {
    attrs: {
      "name": "i_detail",
      "label": "备 注",
      "placeholder": "请填写备注"
    },
    model: {
      value: _vm.itemDetail,
      callback: function callback($$v) {
        _vm.itemDetail = $$v;
      },
      expression: "itemDetail"
    }
  }), _vm.fee !== 0 ? _c('div', {
    staticClass: "fee-box"
  }, [_c('span', {
    staticClass: "fee-txt"
  }, [_vm._v("您的车牌将于3~4日送达，此次收取您的快递到付费用")]), _c('span', {
    staticClass: "fee-value"
  }, [_vm._v("¥" + _vm._s(_vm.fee))])]) : _vm._e(), _c('div', {
    staticClass: "demo-two-box"
  }, [_c('vnp-keyboard', {
    attrs: {
      "codeType": _vm.vehicleType,
      "len": _vm.vehicleType.indexOf('能源') !== -1 ? 8 : 7,
      "show": _vm.showCodeInput
    },
    on: {
      "update:show": function updateShow($event) {
        _vm.showCodeInput = $event;
      }
    },
    model: {
      value: _vm.vehicleCode,
      callback: function callback($$v) {
        _vm.vehicleCode = $$v;
      },
      expression: "vehicleCode"
    }
  })], 1), _c('Verify', {
    ref: "verify",
    attrs: {
      "mode": 'pop',
      "captchaType": 'blockPuzzle',
      "imgSize": {
        width: '330px',
        height: '155px'
      }
    },
    on: {
      "success": _vm.captchaSuccess
    }
  })], 1), _c('div', {
    staticStyle: {
      "margin": "16px"
    }
  }, [_c('van-button', {
    attrs: {
      "round": "",
      "block": "",
      "type": "info",
      "native-type": "submit",
      "color": "linear-gradient(to right, #f0e68c, #daa520)"
    }
  }, [_vm._v("提交")])], 1)])], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "banner-bg"
  })]);
}];
export { render, staticRenderFns };